import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getWoodenPackageTypeList(params) {
  return request({
    url: URL.mdm.basicData.woodenPackageType,
    method: 'get',
    params
  })
}

export function saveWoodenPackageType(data) {
  return request({
    url: URL.mdm.basicData.woodenPackageType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delWoodenPackageType(uuid) {
  return request({
    url: URL.mdm.basicData.woodenPackageType + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
